import { useLang } from '../utils/hooks'
import { langCGU } from '../assets/langCGU'

const CGU = ({ accept, handleAcceptChange }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'eng' ? langCGU.eng : langCGU.fr
  const onAccept = () => {
    handleAcceptChange()
  }
  return (
    <div className="block">
      <div className="content p-1 cgu">
        {choosenLang.articles.map((article) => {
          let item
          switch (article.type) {
            case 'h1':
              item = <h1 className={article.cl}>{article.text}</h1>
              break
            case 'h2':
              item = <p className={article.cl}>{article.text}</p>
              break
            default:
              item = <p className={article.cl}>{article.text}</p>
              break
          }
          return item
        })}
      </div>
      <div className="block">
        <label className="checkbox">
          <input
            type="checkbox"
            className="mr-2"
            checked={accept}
            onChange={onAccept}
          />
          {choosenLang.accept}
        </label>
      </div>
    </div>
  )
}
export default CGU
